import { sample } from 'lodash'

import DamageParticleEffect from "./particle-effects/DamageParticleEffect"
import ParticleEffectEntity from "./particle-effects/ParticleEffectEntity"
import SimpleEntity, { SimpleEntityOptions } from "./SimpleEntity"



export type DamagableEntityOptions = {} & SimpleEntityOptions

const DEAD_VARIANT = [
	'💀',
	'🦴',
	'🦴',
	'🦴',
]

export default class DamagableEntity extends SimpleEntity {

	private damageThreshold = 1
	private currentDamageThreshold = 0

	damage(amt: number) {
		super.damage(amt)

		this.currentDamageThreshold += amt

		if (this.isDead) {
			for (let i = 0; i < 10; i++) {
				this.world.add(this.getDeathParticle())
			}
		} else {
			while (this.currentDamageThreshold >= this.damageThreshold) {
				this.world.add(this.getDamageParticle())
				this.currentDamageThreshold -= this.damageThreshold
			}
		}
	}

	getDamageParticle(): ParticleEffectEntity {
		return new DamageParticleEffect({
			world: this.world,

			x: this.position.x,
			y: this.position.y,

			symbol: '💔'
		})
	}

	getDeathParticle(): ParticleEffectEntity {
		return new DamageParticleEffect({
			world: this.world,

			x: this.position.x,
			y: this.position.y,

			symbol: sample(DEAD_VARIANT),
		})
	}

}